module.exports = __webpack_public_path__ + "img/f3@2x.5390ef17.png";